var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4087 8.28272e-07H0.601623C0.428653 -0.000326355 0.270079 0.0963013 0.19101 0.250186C0.110851 0.406142 0.12492 0.593944 0.227327 0.736377L3.82022 5.79766C3.82142 5.7994 3.82273 5.80104 3.82392 5.80278C3.95447 5.97902 4.02503 6.19246 4.02547 6.41189V10.5383C4.02471 10.6606 4.07269 10.7779 4.15885 10.8646C4.24501 10.9513 4.36214 11 4.48429 11C4.54645 11 4.60785 10.9875 4.66522 10.9637L6.68415 10.1939C6.86508 10.1387 6.98515 9.96802 6.98515 9.76244V6.41189C6.98548 6.19256 7.05615 5.97902 7.18659 5.80278C7.18779 5.80104 7.1891 5.7994 7.1903 5.79766L10.7831 0.736159C10.8855 0.593835 10.8996 0.406142 10.8194 0.250186C10.7403 0.0963013 10.5817 -0.000326355 10.4087 8.28272e-07ZM6.73639 5.472C6.53571 5.74433 6.4272 6.07358 6.42654 6.41189V9.69461L4.58386 10.3972V6.41189C4.5832 6.07358 4.47469 5.74433 4.27391 5.472L0.785826 0.558391H10.2246L6.73639 5.472Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.46986d430789ff9dcdc315e6226a7c20.svg";
export { ForwardRef as ReactComponent };